import { useState } from "react";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
import { useProtectedContent } from "../../hooks/useProtectedContent";
// State Import
import { useUserBranches } from "../../state/userBranchListState";
// MUI
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

export function OrderFilterBar({
  status,
  orderFilter,
  setOrderFilter,
  setColumnVisibilityModel,
  isTypeApproval,
}) {
  const [currentSearchValue, setCurrentSearchValue] = useState(
    orderFilter.search || "",
  );
  const [userBranches, setUserBranches] = useState([]);

  // Hoisted out of the JSX below: called inline it sat behind a && guard, so
  // it only ran on some renders.
  const allowCheckout = useProtectedContent("allowcheckout");

  // Fetch user branches
  const { data, isSuccess } = useUserBranches();
  // Do this on fetch main data success
  const successFunc = () => setUserBranches(data?.data.data.data.list.branch);
  // Do this on fetch main data error
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);
  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.status, successFunc, errorFunc);

  const handleOrderFilterChange = (e) => {
    if (e.target.value === "All") {
      setOrderFilter((prevState) => ({
        ...prevState,
        orderFilter: e.target.value,
        myBranchesFilter: "All",
      }));
    } else {
      setOrderFilter((prevState) => ({
        ...prevState,
        orderFilter: e.target.value,
      }));
    }
  };

  const handleMyBranchesFilterChange = (e) => {
    setOrderFilter((prevState) => ({
      ...prevState,
      myBranchesFilter: e.target.value,
    }));
  };

  const handleApprovalsFilterChange = (e) => {
    if (e.target.value) {
      setOrderFilter((prevState) => ({
        ...prevState,
        showApprovals: e.target.value,
        orderFilter: "Mine",
        myBranchesFilter: "All",
      }));
      // setColumnVisibilityModel((prevState) => ({
      //   ...prevState,
      //   approvalBy: true,
      // }));
    } else {
      setOrderFilter((prevState) => ({
        ...prevState,
        showApprovals: e.target.value,
      }));
      // setColumnVisibilityModel((prevState) => ({
      //   ...prevState,
      //   approvalBy: false,
      // }));
    }
  };

  const handleSearchChange = (newValue) => {
    setCurrentSearchValue(newValue.target.value);
  };

  const handleSearchSumbit = (e) => {
    e.preventDefault();
    setOrderFilter((prevState) => ({
      ...prevState,
      search: currentSearchValue,
    }));
  };

  const handleSearchClear = () => {
    setCurrentSearchValue("");
    setOrderFilter((prevState) => ({
      ...prevState,
      search: "",
    }));
  };

  return (
    <Stack direction={{ xs: "column", md: "row" }} spacing={{ xs: 2, md: 1 }}>
      <Box component="form" onSubmit={handleSearchSumbit} sx={{ flexGrow: 1 }}>
        <TextField
          onChange={handleSearchChange}
          value={currentSearchValue}
          label="Search.."
          id="staff-table-search"
          name="Search"
          variant="outlined"
          size="small"
          fullWidth
          slotProps={{
            input: {
              endAdornment: (
                <>
                  <InputAdornment
                    position="end"
                    sx={{
                      visibility: currentSearchValue ? "visible" : "hidden",
                    }}
                  >
                    <IconButton onClick={handleSearchClear} color="error">
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                  <InputAdornment position="end">
                    <IconButton type="submit">
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                </>
              ),
            },
          }}
        />
      </Box>
      {!isTypeApproval && (
        <Stack direction="row" spacing={1} sx={{ minWidth: { md: 400 } }}>
          {status === "draft" && !allowCheckout && (
            <TextField
              onChange={handleApprovalsFilterChange}
              id="approvals-filter"
              select
              label="Type"
              value={orderFilter.showApprovals}
              size="small"
              fullWidth
            >
              <MenuItem value={"All"}>All</MenuItem>
              <MenuItem value={false}>Draft</MenuItem>
              <MenuItem value={true}>Awaiting Approval</MenuItem>
            </TextField>
          )}
          <TextField
            onChange={handleOrderFilterChange}
            id="order-filter"
            select
            label="Order Filter"
            value={orderFilter.orderFilter}
            size="small"
            fullWidth
          >
            <MenuItem value={"Mine"}>My Orders</MenuItem>
            <MenuItem value={"All"}>Branch Orders</MenuItem>
          </TextField>

          <TextField
            onChange={handleMyBranchesFilterChange}
            id="my-branches-filter"
            select
            label="Branches Filter"
            value={orderFilter.myBranchesFilter}
            disabled={orderFilter.orderFilter === "All" ? false : true}
            size="small"
            fullWidth
          >
            <MenuItem value={"All"} sx={{ fontWeight: "medium" }}>
              All
            </MenuItem>
            {userBranches?.map((branch) => (
              <MenuItem
                key={branch.no}
                value={branch.no}
                sx={{
                  pl: Number(branch.indentation) + 2,
                  fontWeight: !Number(branch.indentation) && "medium",
                }}
              >
                {branch.name}
              </MenuItem>
            ))}
          </TextField>
        </Stack>
      )}
    </Stack>
  );
}
